import React, { useState, Fragment, useContext, useEffect } from 'react';
import AlertaContext from '../../context/alerta/alertaContext';
import AuthContext from '../../context/autenticacion/authContext';

const NuevaCuenta = (props) => {

    // Extraer los valores del context
    const alertaContext = useContext(AlertaContext);
    const { alerta, mostrarAlerta } = alertaContext;

    const authContext = useContext(AuthContext);
    const { mensaje, registrarUsuario } = authContext;

    // En caso de que sea un registro duplicado
    useEffect(() => {
        if(mensaje) {
            mostrarAlerta(mensaje.msg, mensaje.categoria);
            if(mensaje.categoria === 'alerta-ok') {
                // Limpiar campos
                guardarUsuario({ nombre: '', email: '', celular: '', rol: '', password: '', confirmar: '' });
            }
        }
        // eslint-disable-next-line
    }, [ mensaje ]);

    // State para iniciar sesion
    const [ usuario, guardarUsuario ] = useState({
        nombre: '',
        email: '',
        celular: '',
        rol: '',
        password: '',
        confirmar: ''
    });

    // Extraer de usuario
    const { nombre, email, rol, celular, password, confirmar } = usuario;

    const onChange = e => {
        guardarUsuario({
            ...usuario,
            [e.target.name] : e.target.value
        })
    }

    // Cuando el usuario quiere iniciar sesión
    const onSubmit = e => {
        e.preventDefault();

        // Validar que no haya campos vacios
        if( nombre.trim() === '' || email.trim() === '' || celular.trim() === '' || rol.trim() === '' || password.trim() === '' || confirmar.trim() === '' ) {
            return mostrarAlerta('Todos los campos son obligatorios', 'alerta-error', 'cuenta');
        }
        
        // Password minimo de 6 caracteres
        if(password.length < 6) {
            return mostrarAlerta('El password debe ser de al menos 6 caracteres', 'alerta-error', 'cuenta');
        }
        
        // Los 2 passwords son iguales
        if(password !== confirmar) {
            return mostrarAlerta('Los passwords no son iguales', 'alerta-error', 'cuenta');
        }

        // Pasarlo al action
        registrarUsuario({
            nombre,
            email,
            celular,
            rol,
            password
        });
    }

    return (
        <Fragment>
            <h2>Crear Cuenta</h2>
            
            <div className="crear-cuenta">
                
                { alerta ? ( 
                    alerta.categoria !== 'alerta-ok' ? (
                        <div className={`alerta ${alerta.categoria}`}>{alerta.msg}</div> 
                    ) : null                
                ) : null }

                <form
                    onSubmit={onSubmit}
                >
                    <div className="contenedor">
                        <div className="form-group">
                            <input
                                type="text"
                                id="nombre-usuario"
                                name="nombre"
                                placeholder="Tu Nombre"
                                value={nombre}
                                onChange={onChange}
                                className="form-control"
                            />
                            <label className="form-label" htmlFor="nombre-usuario">Nombre</label>
                        </div>
                        <div className="form-group">
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Tu Email"
                                autoComplete="username"
                                value={email}
                                onChange={onChange}
                                className="form-control"
                            />
                            <label className="form-label" htmlFor="email">Email</label>
                        </div>
                    </div>
                    <div className="contenedor">
                        <div className="form-group">
                            <input
                                type="number"
                                id="celular"
                                name="celular"
                                placeholder="Tu Celular"
                                value={celular}
                                onChange={onChange}
                                className="form-control"
                            />
                            <label className="form-label" htmlFor="celular">Celular</label>
                        </div>
                        <div className="form-group">
                            <input
                                type="text"
                                id="rol"
                                name="rol"
                                placeholder="Tu Rol"
                                value={rol}
                                onChange={onChange}
                                className="form-control"
                            />
                            <label className="form-label" htmlFor="rol">Rol/Cargo</label>
                        </div>
                    </div>
                    <div className="contenedor">
                        <div className="form-group">
                            <input
                                type="password"
                                id="password"
                                name="password"
                                placeholder="Tu Password"
                                autoComplete="new-password"
                                value={password}
                                onChange={onChange}
                                className="form-control"
                            />
                            <label className="form-label" htmlFor="password">Password</label>
                        </div>
                        <div className="form-group">
                            <input
                                type="password"
                                id="confirmar"
                                name="confirmar"
                                placeholder="Repite Tu Password"
                                autoComplete="new-password"
                                value={confirmar}
                                onChange={onChange}
                                className="form-control"
                            />
                            <label className="form-label" htmlFor="confirmar">Confirmar Password</label>
                        </div>
                    </div>
                    <div className="contenedor">
                        <div className="form-group">
                            <input
                                type="submit"
                                className="btn btn-primario btn-block"
                                value="Crear Cuenta"
                            />
                        </div>
                    </div>
                </form>
            </div>
        </Fragment>
    );
}
 
export default NuevaCuenta;